import React from 'react'
import styled from 'styled-components';
import resume from '../img/p1.jpeg';
import PrimaryButton from './PrimaryButton';

function ImageSection() {
    return (
        <ImageSectionStyled>
            <div className="left-content">
                <img src={resume} alt=""/>
            </div>
            <div className="right-content">
                <h4>Hey ! ,  I am <span>Sarthak</span></h4>
                <p className="paragraph">
                I like to achieve things by writing as few lines of code as possible. And
that translates to my real life as well. I have worked on microservices
for a product that sees 10 million daily active users and 200,000
requests per minute. I write code that not only serves value to the
users but also saves the company money and time.
                </p>
                <div className="about-info">
                    <div className="info-title">
                        <p>Full Name</p>
                        <p>Age</p>
                        <p>Nationality </p>
                        <p>Languages </p>
                        <p>Location</p>
                        <p>Service</p>
                    </div>
                    <div className="info">
                        <p>: Sarthak</p>
                        <p>: 23</p>
                        <p>: Indian </p>
                        <p>: English , Hindi </p>
                        <p>: India</p>
                        <p>: Full Stack Developer and AI Engineer</p>
                    </div>
                </div>
                <PrimaryButton title={''} />
            </div>
        </ImageSectionStyled>
    )
}


const ImageSectionStyled = styled.div`
    margin-top: 5rem;
    display: flex;
    @media screen and (max-width:1000px){
        flex-direction: column;
        .left-content{
            margin-bottom: 2rem;
        }
    }
    .left-content{
        width: 100%;
        img{
            width: 95%;
            object-fit: cover;
        }
    }
    .right-content{
        width: 100%;
        h4{
            font-size: 2rem;
            color: var(--white-color);
            span{
                font-size: 2rem;
            }
        }
        .paragraph{
            padding: 1rem 0;
        }
        .about-info{
            display: flex;
            padding-bottom: 1.4rem;
            .info-title{
                padding-right: 3rem;
                p{
                    font-weight: 600;
                }
            }
            .info-title, .info{
                p{
                    padding: .3rem 0;
                }
            }
        }
    }
`;
export default ImageSection;
